import { usePermissionsState, useUserState } from "../context";
import { isTeamLegacy } from "../components/SeatsCounter/SeatsCounter";
import { USER_IAM_ROLE } from "types/TeamUsersResponse";
import { OVOU_MAIN_SITE_URL } from "../constants";
import { useFlag } from "utils";
import { FEATURE_FLAGS } from "constants/flags";
import { PAGES } from "constants/pages";

export const useCanOrderCompanyCard = () => {
  const { currentTeam }: { currentTeam: any } = useUserState();
  const { permission } = usePermissionsState();
  const isShopEnabled = useFlag(FEATURE_FLAGS.SHOP);

  const orderCompanyCardUrl = currentTeam?.id
    ? `${OVOU_MAIN_SITE_URL}/checkout/?add-to-cart=60231&team_id=${currentTeam?.id}`
    : "";

  const orderCardForLegacy = `${OVOU_MAIN_SITE_URL}/checkout/?add-to-cart=7146&team_id=${currentTeam?.id}`;
  const orderCardForActive = `${OVOU_MAIN_SITE_URL}/products/teams-add-on?add-to-cart=68083&team_id=${currentTeam?.id}`;

  const orderAddonCardUrl = isShopEnabled
    ? `${PAGES.SHOP}?source=admin`
    : currentTeam?.id
      ? isTeamLegacy(permission?.user_iam_role as USER_IAM_ROLE)
        ? orderCardForLegacy
        : orderCardForActive
      : "";

  return {
    orderCompanyCardUrl,
    orderAddonCardUrl,
  };
};
